// extracted by mini-css-extract-plugin
module.exports = {"block":"i_JW","content":"i_JX","heading":"i_JY","answers":"i_JZ","answer":"i_Ja","unanswered":"i_Jb","answered":"i_Jc","selected":"i_Jd","label":"i_Je"};